import { LegacyAccessTokens } from "features";

const LegacyAccessTokensPage = () => <LegacyAccessTokens />;

export default LegacyAccessTokensPage;
